import get from 'lodash/get';
import { commonFilterOptions, getOption } from 'utils/dateRangeFilterOptions';
import { DATE_FILTER_OPTIONS } from 'xm-constants/importJobs';

export const LOAD = 'LOAD_IMPORT_JOBS';
export const LOAD_START = `${LOAD}_START`;
export const LOAD_SUCCESS = `${LOAD}_SUCCESS`;
export const LOAD_FAIL = `${LOAD}_FAIL`;

export const PAGE = 'PAGE_IMPORT_JOBS';
export const PAGE_START = `${PAGE}_START`;
export const PAGE_SUCCESS = `${PAGE}_SUCCESS`;
export const PAGE_FAIL = `${PAGE}_FAIL`;

export const LOAD_IMPORT = 'LOAD_IMPORT_JOB';
export const LOAD_IMPORT_SUCCESS = `${LOAD_IMPORT}_SUCCESS`;
export const LOAD_IMPORT_FAIL = `${LOAD_IMPORT}_FAIL`;

const uri = '/webapi/xm/1/imports';

const defaultParams = {
  transformType: 'USERS_V1',
  offset: 0,
  limit: 100,
  embed: 'errors',
  sortOrder: 'DESCENDING',
  sortBy: 'started',
};

const defaultLoadImportParams = {
  embed: 'errors,warnings',
};

export const getFilterParams = props => {
  const dateRange = get(props, 'dateRange');
  const params = {};

  if (
    dateRange &&
    dateRange.dateFilterType !== commonFilterOptions.DATE_RANGE.value
  ) {
    const option = getOption(dateRange.dateFilterType, DATE_FILTER_OPTIONS);
    const dateRangeGetter = option.getDateRangeGetter();
    const range = dateRangeGetter();
    params.from = range?.from;
    params.to = range?.to;
  } else {
    params.from = dateRange?.from;
    params.to = dateRange?.to;
  }

  return params;
};

/*
 * Currently used to populate data for (add if used elsewhere):
 * - ImportJobHistoryReport:
 */
export function load(props = {}) {
  const { startIndex = 0, stopIndex = 0, sortBy, sortOrder } = props;

  const params = {
    ...defaultParams,
    limit: Math.max(100, stopIndex - startIndex),
    offset: startIndex,
    ...(sortOrder && { sortOrder: sortOrder.toUpperCase() }),
    ...(sortBy && { sortBy: sortBy.toUpperCase() }),
    ...getFilterParams(props),
  };

  return {
    type: LOAD,
    meta: {
      xmApi: true,
      method: 'get',
      uri,
      params,
    },
  };
}
export function getPage(nextLink) {
  return {
    type: PAGE,
    meta: {
      xmApi: true,
      method: 'get',
      uri: nextLink,
    },
  };
}

export const setIsLoading = () => ({ type: LOAD });
/*
 * Currently used to populate data for (add if used elsewhere):
 * - ImportJobDetailsReport:
 */
export function loadImport(importJobId, params = {}) {
  return {
    type: LOAD_IMPORT,
    meta: {
      xmApi: true,
      method: 'get',
      uri: `${uri}/${importJobId}`,
      params: {
        ...defaultLoadImportParams,
        ...params,
      },
    },
  };
}
